import supabase from "artifact/supabase";
import Form, { style } from "element/form";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";

@define("m-sign-in")
class LogIn extends Form {
  @connected
  @paint
  [trait.template]() {
    return `
      <form class='${style.form}' novalidate>
        <m-email class='${style.form__input}'></m-email>
        <m-password class='${style.form__input}'></m-password>
        <a class='${style.form__a}' href="./forgot-password">Esqueceu a senha?</a>
        <button class='${style.form__button}'>Entrar</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  @filter.validity
  @filter.formData
  async [trait.onSubmit](formData) {
    const { data, error } = await supabase.auth.signInWithPassword(formData);
    error
      ? alert(error.message)
      : location.assign(`/app/${data.user.id}/onboarding`);
    return this;
  }
}

export default LogIn;
